import React from 'react'

function MaleIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="40" viewBox="0 0 48 40">
      <defs>
        <clipPath id="clip-path">
          <path
            fill="none"
            stroke="#707070"
            strokeWidth="1"
            d="M0 0H48V40H0z"
            data-name="Rectangle 7153"
            transform="translate(.444)"
          ></path>
        </clipPath>
      </defs>
      <g clipPath="url(#clip-path)" data-name="male icon" transform="translate(-.444)">
        <g fill="#263238" data-name="Group 51965" transform="translate(8.837 1.81)">
          <path
            d="M9.425-175.481a.92.92 0 01-.753-.39 12.027 12.027 0 01-1.843-7.029 12.581 12.581 0 012.507-7.57 8.95 8.95 0 015.688-3.313 16.567 16.567 0 018.774 1.341 9.846 9.846 0 016 .616 7.845 7.845 0 013.668 3.677c2 4.035 1.039 9.613-2.132 12.435a.921.921 0 01-1.3-.076.921.921 0 01.076-1.3c2.548-2.268 3.329-6.958 1.705-10.242-1.393-2.817-4.212-3.972-7.937-3.251a.921.921 0 01-.524-.052 15.023 15.023 0 00-8.022-1.331 7.159 7.159 0 00-4.553 2.644 10.74 10.74 0 00-2.106 6.46 10.324 10.324 0 001.506 5.928.921.921 0 01-.221 1.284.917.917 0 01-.533.169z"
            data-name="Path 64489"
            transform="translate(-5.215 193.937)"
          ></path>
          <path
            d="M135.476-8.187a.921.921 0 01-.9-.728.921.921 0 01.708-1.094 12.118 12.118 0 003.664-1.6 6.207 6.207 0 003.08-5.918.921.921 0 01.845-.991.921.921 0 01.991.845 8.042 8.042 0 01-3.944 7.63 13.808 13.808 0 01-4.25 1.837.925.925 0 01-.194.019z"
            data-name="Path 64490"
            transform="translate(-134.555 44.607)"
          ></path>
          <path
            d="M52.294-185.569c-2.789 0-5.609-1.57-7.939-4.421a19.188 19.188 0 01-4.041-9.144.906.906 0 01.486-.948 3.612 3.612 0 001.039-.918 2.706 2.706 0 00.4-2.574.921.921 0 01.169-.853.921.921 0 01.8-.332 24.791 24.791 0 004.909-.1c2.263-.284 5.222-1.055 6.466-3.111a.921.921 0 011.265-.311.921.921 0 01.311 1.265c-2.451 4.05-9.167 4.26-11.934 4.163a4.469 4.469 0 01-.975 3.034 5.494 5.494 0 01-1.022 1 17.373 17.373 0 003.55 7.667c1.973 2.415 4.286 3.745 6.512 3.745a5.362 5.362 0 003.312-1.408 15.588 15.588 0 003.138-3.685 23.52 23.52 0 003.048-7.174 5.347 5.347 0 01-4.247-.944 7.643 7.643 0 01-2.012-2.137.921.921 0 01.329-1.261.921.921 0 011.259.326 5.829 5.829 0 001.531 1.6 3.56 3.56 0 003.86.23.921.921 0 01.917.061.921.921 0 01.408.823 22.644 22.644 0 01-3.538 9.468c-2.443 3.828-5.284 5.939-8.001 5.939z"
            data-name="Path 64491"
            transform="translate(-37.001 216.617)"
          ></path>
          <path
            d="M161.006-8.143a.922.922 0 01-.245-.033 17.522 17.522 0 01-5.64-2.545 9.021 9.021 0 01-2.736-3.039 6.074 6.074 0 01-.749-3.76l1.811.341v-.009a4.407 4.407 0 00.625 2.675c1.118 2 3.6 3.575 7.177 4.561a.921.921 0 01.643 1.133.922.922 0 01-.886.676z"
            data-name="Path 64492"
            transform="translate(-131.68 44.563)"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export default MaleIcon
